let isMobileToggleBound = false;

function entertainmentToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('.entertainment > .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`<button type="button" aria-expanded="false">${content}</button>`)
            $(this).siblings().attr('aria-hidden', 'true');
        });
        $('body').on('click.mobileToggle', '.entertainment > .wp-block-heading button', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');
            $(this).parent().siblings().attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');
            $(this).parent().siblings().slideToggle(150, function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('.entertainment > .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`${content}`)
            $(this).siblings().removeAttr('aria-hidden');
        });
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    entertainmentToggle();
    $(window).on('resize', entertainmentToggle);
    updateVisibleFilters();
});

function updateVisibleFilters() {
    const items = document.querySelectorAll('.entertainment__list-item');
    const categoriesWithItems = new Set();

    items.forEach((item) => {
        const category = item.getAttribute('data-category');
        categoriesWithItems.add(category);
    });

    document.querySelectorAll('.entertainment__filters button').forEach((btn) => {
        const filter = btn.getAttribute('data-filter');

        // Кнопка "all" завжди показується
        if (filter === 'all' || categoriesWithItems.has(filter)) {
            btn.style.display = '';
        } else {
            btn.style.display = 'none';
        }
    });
}


document.querySelectorAll('.entertainment__filters button').forEach((btn) => {
    btn.addEventListener('click', () => {
        const filter = btn.getAttribute('data-filter');

        document.querySelectorAll('.entertainment__filters button').forEach((b) => {
            b.classList.remove('active');
            b.setAttribute('aria-selected', "false");
        });

        btn.setAttribute('aria-selected', "true");
        btn.classList.add('active');
        document.querySelectorAll('.entertainment__list-item').forEach((item) => {
            const category = item.getAttribute('data-category');
            if (filter === 'all' || category === filter) {
                item.style.display = '';
            } else {
                item.style.display = 'none';
            }
        });
    });
});